var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "node-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-main', [_c('v-app-bar', {
    attrs: {
      "app": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ws-detail-title"
  }, [_c('v-icon', {
    staticClass: "ml-4 mr-5",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v(" mdi-text-box-multiple ")]), _c('span', {
    staticClass: "breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'workspaceDetail',
        params: {
          workspace: _vm.workspace
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.workspace))]), _c('v-icon', {
    staticClass: "mx-4",
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v(" mdi-chevron-right ")]), _c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v(" mdi-chart-timeline-variant ")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'networkDetail',
        params: {
          network: _vm.network
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.network) + " ")]), _c('v-icon', {
    staticClass: "mx-4",
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v(" mdi-chevron-right ")]), _vm._v(" " + _vm._s(_vm.type) + "/" + _vm._s(_vm.node) + " ")], 1)], 1), _c('v-spacer'), _c('workspace-option-menu', {
    attrs: {
      "workspace": _vm.workspace
    }
  })], 1), _c('v-container', {
    attrs: {
      "id": "node-details",
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "pa-4": ""
    }
  }, [_vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : _c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-title', [_vm._v(" Attributes: " + _vm._s(_vm.attributeTable._id) + " ")]), _c('v-divider'), _c('v-card-text', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "pa-0": ""
    }
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "pa-0": ""
    }
  }, [_c('v-row', _vm._l(_vm.attributes, function (field) {
    return _c('v-col', {
      key: field.key,
      staticClass: "py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('v-list-item', {
      staticStyle: {
        "display": "block"
      }
    }, [_c('v-list-item-subtitle', {
      staticClass: "pt-3 pb-1",
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(" " + _vm._s(field.key) + " ")]), _c('v-list-item-title', {
      staticClass: "pb-3"
    }, [_vm._v(" " + _vm._s(field.value) + " ")]), _c('v-divider')], 1)], 1);
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "pa-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pag-title"
  }, [_vm._v(" Incoming Edges "), _c('div', {
    staticClass: "pagination"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.prevIncoming
    },
    on: {
      "click": function click($event) {
        return _vm.firstPage('incoming');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-previous")])], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.prevIncoming
    },
    on: {
      "click": function click($event) {
        return _vm.turnPage('incoming', false);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _c('span', {
    staticClass: "overline",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v(" " + _vm._s(_vm.currentIncomingPageNumber) + " of " + _vm._s(_vm.lastIncomingPageNumber) + " ")]), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.nextIncoming
    },
    on: {
      "click": function click($event) {
        return _vm.turnPage('incoming', true);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.nextIncoming
    },
    on: {
      "click": function click($event) {
        return _vm.lastPage('incoming');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-next")])], 1)], 1)]), _c('v-card-text', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm.loading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e(), _vm._l(_vm.incoming, function (edge, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "to": "/workspaces/".concat(_vm.workspace, "/network/").concat(_vm.network, "/node/").concat(edge.node)
      }
    }, [_c('v-list-item-content', [_vm._v(" " + _vm._s(edge.node) + " ")])], 1);
  })], 2)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "pa-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pag-title"
  }, [_vm._v(" Outgoing Edges "), _c('div', {
    staticClass: "pagination"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.prevOutgoing
    },
    on: {
      "click": function click($event) {
        return _vm.firstPage('outgoing');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-previous")])], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.prevOutgoing
    },
    on: {
      "click": function click($event) {
        return _vm.turnPage('outgoing', false);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _c('span', {
    staticClass: "overline",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v(" " + _vm._s(_vm.currentOutgoingPageNumber) + " of " + _vm._s(_vm.lastOutgoingPageNumber) + " ")]), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.nextOutgoing
    },
    on: {
      "click": function click($event) {
        return _vm.turnPage('outgoing', true);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.nextOutgoing
    },
    on: {
      "click": function click($event) {
        return _vm.lastPage('outgoing');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-next")])], 1)], 1)]), _c('v-card-text', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm.loading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e(), _vm._l(_vm.outgoing, function (edge, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "to": "/workspaces/".concat(_vm.workspace, "/network/").concat(_vm.network, "/node/").concat(edge.node)
      }
    }, [_c('v-list-item-content', [_vm._v(" " + _vm._s(edge.node) + " ")])], 1);
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }